const rootPath = ''

export const navigationPaths = {
  root: () => `/`,

  dashboard: () => `/`,
  reconciliationsIndex: () => `${rootPath}/shop_orders/reconciliations`,
  shopOrdersShow: () => `${rootPath}/shop_orders/:id`,
  shopOrderHistory: (id) => `${rootPath}/shop_orders/${id}/history`,
  shopOrdersIndex: () => `${rootPath}/shop_orders`,
  signIn: () => `${rootPath}/sign_in`,
  signOut: () => `${rootPath}/sign_out`,
}

export const routerPaths = {
  root: `/`,

  dashboard: `/`,
  reconciliationsIndex: `${rootPath}/shop_orders/reconciliations`,
  shopOrdersShow: `${rootPath}/shop_orders/:id`,
  shopOrderHistory: `${rootPath}/shop_orders/:id/history`,
  shopOrdersIndex: `${rootPath}/shop_orders`,
  signIn: `${rootPath}/sign_in`,
  signOut: `${rootPath}/sign_out`
}
